<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M12.75 12.7643C22.7851 13.1488 30.8512 21.2149 31.2357 31.25H12.75V12.7643Z" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
